import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getProductsByName = (
    token: string,
    backend: string,
    productName: string
) => {
    return fetch(
        `${getApiUrl(backend)}products/by_name/${productName}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json, text/plain, */*'
            },
        }
    );
};

export default getProductsByName;